// extracted by mini-css-extract-plugin
export default {"modify_order_header":"Vu","center":"Wu","empty":"Xu","pending":"Yu","referralTitle":"Zu","wrapper":"av","title":"bv","tabs":"cv","tab":"ev","active":"fv","btn":"gv","rewards_table":"hv"};
    if(module.hot) {
      // 1711717530996
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  